import { render } from "./LieveTandarts.vue?vue&type=template&id=5b85ffb2&scoped=true"
import script from "./LieveTandarts.vue?vue&type=script&lang=js"
export * from "./LieveTandarts.vue?vue&type=script&lang=js"

import "./LieveTandarts.vue?vue&type=style&index=0&id=5b85ffb2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b85ffb2"]])

export default __exports__